import {charcoal} from '../../sass/v2/_exports.sass';

export const MailIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Envelope</title>
      <path
        d="M4.8 27C4.03 27 3.37083 26.7307 2.8225 26.1922C2.27417 25.6536 2 25.0063 2 24.25V7.75C2 6.99375 2.27417 6.34635 2.8225 5.80781C3.37083 5.26927 4.03 5 4.8 5H27.2C27.97 5 28.6292 5.26927 29.1775 5.80781C29.7258 6.34635 30 6.99375 30 7.75V24.25C30 25.0063 29.7258 25.6536 29.1775 26.1922C28.6292 26.7307 27.97 27 27.2 27H4.8ZM16 17.375L4.8 10.5V24.25H27.2V10.5L16 17.375ZM16 14.625L27.2 7.75H4.8L16 14.625ZM4.8 10.5V7.75V24.25V10.5Z"
        fill={color}
      />
    </svg>
  );
};
